import React from 'react';
import { Link } from 'react-router-dom';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import PhoneOutlinedIcon from '@mui/icons-material/PhoneOutlined';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined';
import '../styles/StorefrontPages.css';

const CONTACTS = [
  {
    Icon: PhoneOutlinedIcon,
    label: 'Телефон',
    primary: '+7 (727) 000-00-00',
    secondary: 'Будни 9:00 — 19:00',
    href: 'tel:+77270000000',
  },
  {
    Icon: EmailOutlinedIcon,
    label: 'Email',
    primary: 'sales@mb4.kz',
    secondary: 'Ответ в течение часа',
    href: 'mailto:sales@mb4.kz',
  },
  {
    Icon: LocationOnOutlinedIcon,
    label: 'Адрес',
    primary: 'г. Алматы, ул. Розыбакиева, 247',
    secondary: 'БЦ «MB4 Plaza», 3 этаж',
    href: null,
  },
  {
    Icon: AccessTimeOutlinedIcon,
    label: 'Часы работы',
    primary: 'Пн — Пт: 09:00 — 19:00',
    secondary: 'Сб — Вс: по запросу',
    href: null,
  },
];

const ContactPage = () => {
  return (
    <div className="sfpage">
      <div className="sfpage__head">
        <span className="sfpage__eyebrow">Связь с нами</span>
        <h1 className="sfpage__title">Свяжитесь с MB4</h1>
        <p className="sfpage__lead">
          Мы поможем выбрать отруб, рассчитаем доставку и оформим договор для постоянных закупок.
        </p>
      </div>

      <div className="sfpage__grid sfpage__grid--2">
        {CONTACTS.map(({ Icon, label, primary, secondary, href }) => (
          <div key={label} className="sfcard">
            <div className="sfcard__icon"><Icon /></div>
            <div className="sfcard__body">
              <span className="sfcard__label">{label}</span>
              {href
                ? <a className="sfcard__primary sfcard__primary--link" href={href}>{primary}</a>
                : <span className="sfcard__primary">{primary}</span>}
              <span className="sfcard__secondary">{secondary}</span>
            </div>
          </div>
        ))}
      </div>

      <div className="sfpage__cta">
        <div>
          <h3 className="sfpage__cta-title">Нужен договор поставки?</h3>
          <p className="sfpage__cta-text">
            Отправим оферту и согласуем регулярные поставки в течение одного рабочего дня.
          </p>
        </div>
        <Link to="/" className="sfpage__cta-btn">Оставить заявку</Link>
      </div>
    </div>
  );
};

export default ContactPage;
